const SolutionSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-3 bg-pink-100 px-6 py-3 rounded-full mb-6">
            <img 
              src="https://static.readdy.ai/image/f188085399ab07ac2c79984c802b33af/d7137dec17d438e55dac1175e416585f.png" 
              alt="Genie" 
              className="w-8 h-8"
            />
            <span className="text-pink-700 font-semibold text-base">Your Solution</span>
          </div>
          
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            With ReceptionGenie, You'll Never Miss a Call, Lead, or Opportunity Again
          </h2>
          
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Meet your new AI receptionist that works 24/7 to ensure your business feels approachable and professional
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          {/* Card 1 */}
          <div className="bg-gradient-to-br from-pink-50 to-purple-50 rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
            <div className="w-16 h-16 bg-pink-500 rounded-2xl flex items-center justify-center mb-6">
              <i className="ri-phone-line text-white text-3xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Answers Every Call</h3>
            <p className="text-gray-600 leading-relaxed mb-4">
              Responds to leads and clients immediately, even when you're unavailable.
            </p>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-pink-600 text-xl flex-shrink-0 mt-0.5"></i>
                <span className="text-gray-700">Instant response to every caller</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-pink-600 text-xl flex-shrink-0 mt-0.5"></i>
                <span className="text-gray-700">Professional greeting every time</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-pink-600 text-xl flex-shrink-0 mt-0.5"></i>
                <span className="text-gray-700">Never miss a potential customer</span>
              </li>
            </ul>
          </div>
          
          {/* Card 2 */}
          <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
            <div className="w-16 h-16 bg-blue-500 rounded-2xl flex items-center justify-center mb-6">
              <i className="ri-question-answer-line text-white text-3xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Handles Common Questions</h3>
            <p className="text-gray-600 leading-relaxed mb-4">
              Answers frequently asked questions with accurate, helpful information.
            </p>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-blue-600 text-xl flex-shrink-0 mt-0.5"></i>
                <span className="text-gray-700">"What's your availability?"</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-blue-600 text-xl flex-shrink-0 mt-0.5"></i>
                <span className="text-gray-700">"Can I get a quote?"</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-blue-600 text-xl flex-shrink-0 mt-0.5"></i>
                <span className="text-gray-700">"What's your process?"</span>
              </li>
            </ul>
          </div>
          
          {/* Card 3 */}
          <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
            <div className="w-16 h-16 bg-purple-500 rounded-2xl flex items-center justify-center mb-6">
              <i className="ri-calendar-check-line text-white text-3xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Books Appointments</h3>
            <p className="text-gray-600 leading-relaxed mb-4">
              Schedules appointments directly onto your calendar automatically.
            </p>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-purple-600 text-xl flex-shrink-0 mt-0.5"></i>
                <span className="text-gray-700">Automatic calendar integration</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-purple-600 text-xl flex-shrink-0 mt-0.5"></i>
                <span className="text-gray-700">Sends confirmation messages</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-purple-600 text-xl flex-shrink-0 mt-0.5"></i>
                <span className="text-gray-700">Reduces no-shows with reminders</span>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="text-center mt-12">
          <a 
            href="tel:+18886009252"
            className="inline-block whitespace-nowrap px-8 py-4 bg-pink-500 hover:bg-pink-600 text-white font-semibold rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer"
          >
            Call our demo
          </a>
        </div>
      </div>
    </section>
  );
};

export default SolutionSection;